export class ReceivementConferenceRequestModel {
    bkSubDivsionUidK?:number;
    userC?:string;
    language?:string;
    siteCode?:string;
    bkwarehouseUidK?:number;
    groupNum?:number;
    docCode?:string;
    partCode?:string;
    gspnCode?:string;
    boxCode?:string;
    groupId?:number;
    receivingLabelNum?:number;
    receivingQty?:number;
    receivingDate?:Date;
    receivingCounted?:number;
    status?:boolean;
	updateS?: string;
}
